<template>
    <login-content></login-content>
</template>

<script>
import LoginContent from "@/components/pages/login/content/LoginContent";

export default {
    name: "LoginPage",
    components: { LoginContent },
};
</script>
